import React, { Component } from 'react';
import $ from "jquery";

export default class OptSearch4 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dynamicId: ""
        }
    }

    submitOptForm = (needReload = false) => {
        let match = "{";
        var inputText = $("#search-text").val();

        const OptSearchUrl = window.location.pathname;
        let params = {};

        $("p.selected").text(inputText);
        $("p.selected").attr("data-value", inputText);

        let searchValue = $("td.search-row-text").find("p.selected").data("value") || "";
        if (searchValue) {
            params["search"] = searchValue;
        }

        $(".search-row").not(".search-row-text").each(function () {
            var title = $(this).children(".search-form__td-title").attr("value");
            var value = $(this).find("li.selected").attr("value");
            //console.log($(this).children(".search-form__td-title").attr("value"));
            //console.log("Title: " + title + ", Value: " + value);
            if (title && value) {
                params[title] = value;
                match += `"${title}":"${value}", `;
                sessionStorage.setItem(title, value);
            }
        });

        let queryString = Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

        //console.log("Query String: " + queryString);

        let newUrl = `${OptSearchUrl}?${queryString}`;
        window.history.pushState(null, '', newUrl);

        if (needReload) {
            //console.log("Reloading page with new parameters.");
            window.location.reload();
        }
    }

    clear = () => {
        sessionStorage.clear();
        window.location.reload();
    }

    componentDidMount() {
        const currentPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        sessionStorage.setItem('OptSearchUrl', currentPath);

        const searchText = String(urlParams.get('search'))
        const title = String(urlParams.get('id_title'))
        const sender = String(urlParams.get('id_sender'))
        const recipient = String(urlParams.get('id_recipient'))
        const year_start = String(urlParams.get('id_year_start'))
        const year_stop = String(urlParams.get('id_year_stop'))

        let setReload = true;
        let optSearchObj = {};

        if (searchText) {
            sessionStorage.setItem('search', searchText);
            optSearchObj["search"] = searchText;
        }
        if (title) {
            sessionStorage.setItem('id_title', title);
            optSearchObj["id_title"] = title;
        }
        if (sender) {
            sessionStorage.setItem('id_sender', sender);
            optSearchObj["id_sender"] = sender;
        }
        if (recipient) {
            sessionStorage.setItem('id_recipient', recipient);
            optSearchObj["id_recipient"] = recipient;
        }
        if (year_stop) {
            sessionStorage.setItem('id_year_stop', year_stop);
            optSearchObj["id_year_stop"] = year_stop;
        }
        if (year_start) {
            sessionStorage.setItem('id_year_start', year_start);
            optSearchObj["id_year_start"] = year_start;
        }

        sessionStorage.setItem('OptSearch', JSON.stringify(optSearchObj));

        this.loadFiltersFromSessionStorage();

        if (!sessionStorage.getItem('submitFormCalled') && setReload) {
            this.submitOptForm();
            sessionStorage.setItem('submitFormCalled', 'true');
        } else {
            const storedTitle = sessionStorage.getItem('id_title');
            const storedSender = sessionStorage.getItem('id_sender');
            const storedRecipient = sessionStorage.getItem('id_recipient');
            const storedYear = sessionStorage.getItem('id_year');
            const storedYear_start = sessionStorage.getItem('year_start');

            if (
                title === storedTitle &&
                sender === storedSender &&
                recipient === storedRecipient &&
                year_stop === storedYear &&
                year_start === storedYear_start
            ) {
                setReload = false;
                sessionStorage.removeItem('submitFormCalled');
                //console.log('Filtry są takie same, nie wymagają przeładowania.');
            }
        }

        if (year_start === "null") {
            $("#year_start").val("");
        } else {
            $("#year_start").val(year_start);
        }
    }

    loadFiltersFromSessionStorage() {
        let searchText = sessionStorage.getItem('search');
        let title = sessionStorage.getItem('id_title');
        let sender = sessionStorage.getItem('id_sender');
        let recipient = sessionStorage.getItem('id_recipient');
        let year_stop = sessionStorage.getItem('id_year_stop');
        let year_start = sessionStorage.getItem('id_year_start');

        const urlParams = new URLSearchParams(window.location.search);
        const searchTextUrl = urlParams.get('search');
        const titleUrl = urlParams.get('id_title');
        const senderUrl = urlParams.get('id_sender');
        const year_stopUrl = urlParams.get('id_year_stop');
        const year_startUrl = urlParams.get('id_year_start');
        const recipientUrl = urlParams.get('id_recipient');

        if ((searchText != null && searchText === searchTextUrl)) {
            $("#search-text").val(searchText);
            $("p.selected").text(searchText);
            $("p.selected").attr("data-value", searchText);
        }

        if (title != null && title === titleUrl) {
            $("#title li").removeClass("selected");
            $("#title li").each(function () {
                if ($(this).attr("value") === title) {
                    $(this).addClass("selected");
                }
            });
        }

        if (sender != null && sender === senderUrl) {
            $("#sender li").removeClass("selected");
            $("#sender li").each(function () {
                if ($(this).attr("value") === sender) {
                    $(this).addClass("selected");
                }
            });
        }

        if (recipient != null && recipient === recipientUrl) {
            $("#recipient li").removeClass("selected");
            $("#recipient li").each(function () {
                if ($(this).attr("value") === recipient) {
                    $(this).addClass("selected");
                }
            });
        }

        if (year_stop != null && year_stop === year_stopUrl) {
            $("#year_stop li").removeClass("selected");
            $("#year_stop li").each(function () {
                if ($(this).attr("value") === year_stop) {
                    $(this).addClass("selected");
                    //console.log($(this).attr("value"));
                }
            });
        }

        if (year_start != null && year_start === year_startUrl) {
            $("#year_start li").removeClass("selected");
            $("#year_start li").each(function () {
                if ($(this).attr("value") === year_start) {
                    $(this).addClass("selected");
                    //console.log($(this).attr("value"));
                }
            });
        }
    }

    render() {

        document.addEventListener("keypress", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("search-engine-submit").click();
            }
        });

        $(function () {
            $(".select-container ul").unbind().click(function () {
                $(this).toggleClass("opened");
            });

            $("#optional-search-form ul li").click(function () {
                var match = "{";
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
                $("p.selected").attr("value", inputText)

                if ($(this).hasClass("selected")) {
                }
                else {
                    $(this).addClass("selected").siblings().removeClass("selected");

                    const parentId = $(this).parent("ul").attr('id');
                    const itemValue = $(this).attr("value");
                    sessionStorage.setItem(`id_${parentId}`, itemValue)

                    $(".search-row").each(function () {
                        var title = $(this).children(".search-form__td-title").attr("value");
                        var value = $(this).find(".selected").attr("value");
                        match += '"' + title + '":';
                        match += '"' + value + '", ';
                    });

                }
                match = match.slice(0, -2);
                match += "}";
                sessionStorage.setItem("OptSearch4", match);
            });

            $('#search-text').on('input', function (e) {
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
            });

        });

        $(document).mouseup(function (e) {
            var container = $(".select-container ul.opened");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass("opened");
            }
        });

        // LABELS BASED ON LANGUAGE
        let search_label_1 = window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
        let search_label_2 = window.location.href.indexOf("/en/") > -1 ? "Enter a search phrase" : "Wpisz szukaną frazę";
        let search_label_3 = window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
        let search_label_4 = window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
        let search_label_5 = window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

        return (
            <div className="optional-search-container">
                <form id="optional-search-form" className="OptSearch4">
                    <table>
                        <tbody>
                            <tr className="search-row">
                                <td colSpan={2} className="search-row-text search-form__td-title" value="search">
                                    <input aria-label="search input" id="search-text" name="search" type="text" placeholder={search_label_2} />
                                    <p className="selected" style={{ margin: 0 }}></p>
                                </td>
                            </tr>
                            <tr>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[0].field_name}>{this.props.filter_search[0].name}</span>
                                    <div className="select-container">
                                        <ul id="title">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[0].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li key={index} value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[1].field_name}>{this.props.filter_search[1].name}</span>
                                    <div className="select-container">
                                        <ul id="sender">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[1].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li key={index} value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[2].field_name}>{this.props.filter_search[2].name}</span>
                                    <div className="select-container">
                                        <ul id="recipient">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[2].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li key={index} value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                                <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[3].field_name}>{this.props.filter_search[3].name}</span>
                                    <div className="select-container">
                                        <ul id="year_start">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[3].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li key={index} value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="search-row" colSpan={2}><span className="search-form__td-title" value={this.props.filter_search[4].field_name}>{this.props.filter_search[4].name}</span>
                                    <div className="select-container">
                                        <ul id="year_stop">
                                            <li className="selected" value="">{search_label_4}</li>
                                            {this.props.filter_search[3].list.map(function (item, index) {
                                                var name = item.name;
                                                var id = item.id;
                                                return (
                                                    <li key={index} value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>

                    <div className="search-engine-options">
                        <button onClick={this.clear}>{search_label_1}</button>
                        <button id="search-engine-submit" className="submit" onClick={(e) => { e.preventDefault(); this.submitOptForm(true); }}>{search_label_3}</button>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch4/OptSearch4.js